// Decodes the encoded polyline points of every step in a Google Maps
// DirectionsResult into a flat array of LatLng objects.
//
// The decoding needs the Maps "geometry" library (`google.maps.geometry.encoding`).
// The loader requests that library, but a partially loaded Maps API can resolve
// without it - in that case we return an empty path instead of throwing an
// uncaught "Cannot read properties of undefined (reading 'encoding')", which
// would otherwise fail the page (and the specs driving it).
export function decodeDirectionsPath(legs, geometryEncoding) {
  if (!geometryEncoding) {
    return []
  }

  const path = []

  for (const leg of legs) {
    for (const step of leg.steps) {
      for (const pathElement of geometryEncoding.decodePath(step.polyline.points)) {
        path.push(pathElement)
      }
    }
  }

  return path
}
